import {
  UPDATE_TEACHER_ROLE_REQUEST,
  UPDATE_TEACHER_ROLE_SUCCESS,
  UPDATE_TEACHER_ROLE_FAILURE,
} from "../Actions/updateTeacherRoleAction";

const initialState = {
  loading: false,
  message: null,
  error: null,
};

export const updateTeacherRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TEACHER_ROLE_REQUEST:
      return { ...state, loading: true, message: null, error: null };
    case UPDATE_TEACHER_ROLE_SUCCESS:
      return { ...state, loading: false, message: action.payload };
    case UPDATE_TEACHER_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
